import Button from 'client/shared/blocks/button/button'
import { Heading } from 'client/shared/blocks/heading/heading'
import Spacer from 'client/shared/blocks/spacer/spacer'
import StoreButtonBox from 'client/shared/boxes/store-button-box'
import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'
import { Location } from 'client/shared/types/react-router'
import React, { Component } from 'react'
import urlHelper from 'shared/tools/url-helper'
import ShareFBimage from 'client/bookmate/pages/originals/assets/feelings/facebook.png'
import ShareTWimage from 'client/bookmate/pages/originals/assets/feelings/twitter.png'
import { MetaDescription } from 'client/shared/blocks/meta-description/meta-description'
import MetaTitle from 'client/shared/blocks/meta-title/meta-title'
import Meta from 'client/shared/blocks/meta/meta'
import HeaderBox from 'client/shared/boxes/header-box'
import Footer from 'client/shared/blocks/footer/footer'
import { LayoutColumn } from 'client/shared/blocks/layout-column/layout-column'
import Author1 from 'client/bookmate/pages/originals/assets/feelings/author-1.png'
import Author2 from 'client/bookmate/pages/originals/assets/feelings/author-2.png'
import Author3 from 'client/bookmate/pages/originals/assets/feelings/author-3.png'
import Author4 from 'client/bookmate/pages/originals/assets/feelings/author-4.png'
import Author5 from 'client/bookmate/pages/originals/assets/feelings/author-5.png'
import Author6 from 'client/bookmate/pages/originals/assets/feelings/author-6.png'
import Author7 from 'client/bookmate/pages/originals/assets/feelings/author-7.png'
import Author8 from 'client/bookmate/pages/originals/assets/feelings/author-8.png'
import Author9 from 'client/bookmate/pages/originals/assets/feelings/author-9.png'
import Author10 from 'client/bookmate/pages/originals/assets/feelings/author-10.png'
import Ellipse1 from 'client/bookmate/pages/originals/assets/feelings/ellipse-1.png'
import Ellipse2 from 'client/bookmate/pages/originals/assets/feelings/ellipse-2.png'
import Ellipse3 from 'client/bookmate/pages/originals/assets/feelings/ellipse-3.png'
import Ellipse4 from 'client/bookmate/pages/originals/assets/feelings/ellipse-4.png'
import Ellipse5 from 'client/bookmate/pages/originals/assets/feelings/ellipse-5.png'
import Mobile1 from 'client/bookmate/pages/originals/assets/feelings/mobile-1.png'
import Mobile2 from 'client/bookmate/pages/originals/assets/feelings/mobile-2.png'
import Mobile3 from 'client/bookmate/pages/originals/assets/feelings/mobile-3.png'
import Mobile4 from 'client/bookmate/pages/originals/assets/feelings/mobile-4.png'
import Mobile5 from 'client/bookmate/pages/originals/assets/feelings/mobile-5.png'
import Mobile6 from 'client/bookmate/pages/originals/assets/feelings/mobile-6.png'
import Mobile7 from 'client/bookmate/pages/originals/assets/feelings/mobile-7.png'

import './feelings.styl'
import './common.styl'
import { Loader } from 'client/shared/blocks/loader/loader'

type Props = {
  location: Location
} & DecoratorProps

class FeelingsOriginal extends Component<Props, { isButtonHidden: boolean }> {
  timer: any = null

  state = {
    isButtonHidden: false,
  }

  componentDidUpdate(): void {
    if (this.state.isButtonHidden) {
      this.timer = setTimeout(
        () => this.setState({ isButtonHidden: false }),
        3000,
      )
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  hideButton(): void {
    this.setState({ isButtonHidden: true })
  }

  render(): JSX.Element {
    const { isMobileSize, location, isTabletSize } = this.props
    const isMobile = isMobileSize()
    const isTablet = isTabletSize()

    return (
      <>
        {this.state.isButtonHidden ? (
          <div className="loading-shade">
            <Spacer size={140} />
            <Loader color="gray" kind="big" centered />
            <Spacer size="bottom-page" />
          </div>
        ) : null}
        <MetaTitle
          disableSuffix
          title="Bookmate поносно представља сериjaл И ТО JE У РЕДУ"
        />
        <MetaDescription description="Кроз 24 електронске и аудио приче, бавимо се битним емоцијама са којима се малишани можда први пут сусрећу. Читајте и слушајте на Bookmate апликацији" />
        <Meta content={ShareFBimage} property="og:image" />
        <Meta content={ShareTWimage} property="twitter:image" />
        <Meta content="summary_large_image" property="twitter:card" />
        <HeaderBox />
        <div className="landing_wrapper">
          <div className="landing-wrapper_bg" />
          <div className="landing-into_bg" />
          <Heading className="landing-intro_heading" kind="graphik" centered>
            Bookmate поносно представља серијал о великим емоцијама малих људи
          </Heading>
          <Spacer size={24} />
          <img
            className="book-title_svg"
            src="https://a.bmstatic.com/iu/206/221/title-6b8f9acf36b1c52e2ec6692326421b7e.svg"
            alt="И то je у реду"
          />
          <Spacer size={24} />
          <p className="landing-intro_desc">
            Кроз 24 електронске и аудио приче за децу предшколског и
            раношколског узраста, бавимо се битним емоцијама са којима се
            малишани можда по први пут сусрећу баш у овом развојном добу, међу
            којима су љубомора, кривица и страх.
          </p>
          <Spacer size={32} />
          <div className="landing_column">
            {!this.state.isButtonHidden ? (
              <div
                onClick={() => this.hideButton()}
                className="landing_books-buttons"
              >
                <Button
                  className="landing-button_book"
                  path={urlHelper.book('bhvgL5AA', location.query)}
                >
                  <img
                    src="https://a.bmstatic.com/iu/44/170/Read-381d30f9cbf469e47c618ce164a31f94.svg"
                    alt="читај"
                  />
                  читај {!isMobile && 'одмах'}
                </Button>
                <Button
                  className="landing-button_audiobook"
                  path={urlHelper.audioBook('XRqhicrv', location.query)}
                >
                  <img
                    src="https://a.bmstatic.com/iu/221/85/Listen-37e862dc0c50eac165df11dc73934624.svg"
                    alt="слушај"
                  />
                  слушај {!isMobile && 'одмах'}
                </Button>
              </div>
            ) : (
              <div className="spaceholder_button" />
            )}
            <Spacer size={48} />
            <img
              className="bookmate-logo"
              src="https://a.bmstatic.com/iu/37/196/outside-originalsUPD-728296496f70efa942a27b46e564bf34.svg"
              alt="Bookmate logo"
            />
            <Spacer size={56} />
            <div className="author-section">
              <Heading rank={2}>
                <b>Тијана Телечки</b>,{isMobile ? null : <br />} психолошкиња
              </Heading>
              <Spacer size={24} />
              <p>
                Основе менталног здравља постављају се од раног детињства. Нови
                Bookmate дечји пројекат о емоцијама је важан управо из разлога
                што доприноси адекватном препознавању и разумевању емоција већ
                на дечијем узрасту.
              </p>
            </div>
            <div className="teaser-section">
              <LayoutColumn size={isTablet ? 8 : 10} centered>
                <div className="author-item">
                  <img
                    className="author-item_image left"
                    src={isMobile ? Mobile1 : Author1}
                    alt="Владислава Војновић"
                  />
                  {isMobile && <Spacer size={40} />}
                  <p>
                    <Heading rank={4}>
                      <b>Владислава Војновић</b>
                      <br />
                      списатељица и сценаристкиња
                    </Heading>
                    <Spacer />
                    Говорећи о емоцијама признајемо им да постоје и чинимо их
                    видљивим. Кад човек види ствари, мање су шансе да ће се о
                    њих саплести.
                  </p>
                </div>
                <div className="author-item">
                  {isMobile ? (
                    <img
                      className="books-sample"
                      src={Author3}
                      alt="i to je u redu"
                    />
                  ) : (
                    <img
                      className="author-item_image right"
                      src={Author2}
                      alt="Дејан Алексић"
                    />
                  )}
                  {isMobile && (
                    <>
                      <Spacer size={24} />
                      <PlayerSampleOne
                        isMobile={isMobile}
                        isTablet={isTablet}
                      />
                      <Spacer size={32} />
                      <img
                        className="author-item_image right"
                        src={Author2}
                        alt="Дејан Алексић"
                      />
                      <Spacer size={40} />
                    </>
                  )}
                  <p>
                    <Heading rank={4}>
                      <b>Дејан Алексић</b>
                      <br />
                      писац
                    </Heading>
                    <Spacer />
                    Литература је један од начина да се деца уведу у свет. Стога
                    је важно да се дете у читалачком акту изложи ситуацијама
                    које су у животу реалне, које подразумевају утицај на
                    унутрашњи свет детета и његове емоције. А знамо да у
                    реалности оне нису увек добре, пожељне и пријатне. Ефекат
                    добре књижевности је обично катартичан. Дете, читајући добре
                    приче, у овом контексту, то увек добро осети.
                  </p>
                  {!isMobile && (
                    <div>
                      <img
                        className="books-sample"
                        src={Author3}
                        alt="i to je u redu"
                      />
                      <Spacer size={32} />
                      <PlayerSampleOne
                        isMobile={isMobile}
                        isTablet={isTablet}
                      />
                    </div>
                  )}
                </div>
                <div className="author-item">
                  <img
                    className="author-item_image left"
                    src={isMobile ? Mobile2 : Author4}
                    alt="Јелена Ангеловски"
                  />
                  {isMobile && <Spacer size={40} />}
                  <p>
                    <Heading rank={4}>
                      <b>Јелена Ангеловски</b>
                      <br />
                      списатељица
                    </Heading>
                    <Spacer />
                    Моја прва и најдража читалачка искуства увек је пратило исто
                    сазнање: нисам сама, још неком се то исто дешава, још неко
                    мисли као ја, још неко се осећа као ја. Нарочито ми је ово
                    последње било важно. То је мојим осећањима некад давало име,
                    некад контекст, некад објашњење или важност, али најчешће и
                    најбитније – давало им је уметнички израз, ону кашику шећера
                    која помаже да горак лек стварности лакше прогутамо.
                  </p>
                </div>
                <div className={`author-item${isMobile ? '' : ' margined'}`}>
                  {isMobile ? (
                    <>
                      <img
                        className="author-item_image left"
                        src={Mobile3}
                        alt="Андреја Каргачин"
                      />
                      <Spacer size={40} />
                    </>
                  ) : (
                    <img
                      className="author-item_image right"
                      src={Author5}
                      alt="Андреја Каргачин"
                    />
                  )}
                  <p>
                    <Heading rank={4}>
                      <b>Андреја Каргачин</b>
                      <br />
                      редитељка, списатељица, уметница перформанса и чланица Шок
                      Задруге
                    </Heading>
                    <Spacer />
                    Мислим да је важно писати о емоцијама у свакој врсти
                    књижевности јер су емоције део онога што нас чини једнакима.
                    Сви смо људи и наше емоције и наша машта нас чини људима, а
                    све разлике су разлике средине у којој се налазимо, наша срж
                    је увек иста. Нарочито је важно писати о емоцијама у
                    књижевности за децу јер тако показујемо да уважавамо децу
                    као равноправне чланове људске заједнице.
                  </p>
                  {!isMobile && (
                    <img
                      className="books-sample margined"
                      src={Author6}
                      alt="i to je u redu"
                    />
                  )}
                </div>
                <Spacer size={56} />
              </LayoutColumn>
            </div>
            <div className="releases_desc">
              <Heading rank={3}>Hова прича сваке две недеље</Heading>
              <p>
                Ваши малишани могу да преслушају аудио-књиге и коментаришу их са
                вама, или можете заједно да читате електронске књиге, дајући им
                тон, глас и објашњење на лицу места.
              </p>
              <Spacer size={32} />
              <div className="store-buttons_group">
                <StoreButtonBox inverted platform="ios" size="big" />
                <StoreButtonBox inverted platform="android" size="big" />
              </div>
            </div>
            <div className="authors-outro">
              <LayoutColumn size={isTablet ? 8 : 10} centered>
                <div className="author-item">
                  <div>
                    {isMobile ? (
                      <img
                        className="books-sample"
                        src={Mobile4}
                        alt="i to je u redu"
                      />
                    ) : (
                      <img
                        className="author-item_image left"
                        src={Author7}
                        alt="Ивана Нешић"
                      />
                    )}
                    {isMobile && <Spacer />}
                    <span>Послушајте кратке одломке</span>
                    <Spacer />
                    <iframe
                      title="Послушајте кратке одломке"
                      width={isTablet || isMobile ? 300 : 420}
                      height="370"
                      scrolling="no"
                      frameBorder="no"
                      allow="autoplay"
                      src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1632063064%3Fsecret_token%3Ds-Elf3TWWz77e&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
                    ></iframe>
                    <div
                      style={{
                        fontSize: '10px',
                        color: '#cccccc',
                        lineBreak: 'anywhere',
                        wordBreak: 'normal',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        fontFamily:
                          'Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif',
                        fontWeight: 100,
                      }}
                    >
                      <a
                        href="https://soundcloud.com/bookmate-891163390"
                        title="Bookmate"
                        target="_blank"
                        style={{ color: 'white', textDecoration: 'none' }}
                      >
                        Bookmate
                      </a>{' '}
                      ·{' '}
                      <a
                        href="https://soundcloud.com/bookmate-891163390/sets/i-to-je-u-reduu"
                        title="И то је у реду"
                        target="_blank"
                        style={{ color: 'white', textDecoration: 'none' }}
                      >
                        И то је у реду
                      </a>
                    </div>
                  </div>
                  <p>
                    {isMobile && (
                      <>
                        <Spacer size={64} />
                        <img
                          className="author-item_image right"
                          src={Mobile5}
                          alt="Ивана Нешић"
                        />
                        <Spacer size={40} />
                      </>
                    )}
                    <Heading rank={4}>
                      <b>Ивана Нешић</b>
                      <br />
                      списатељица и историчарка уметности
                    </Heading>
                    <Spacer />
                    За мене су емоције најважнији део наше стварности. Чак и
                    када верујемо да разум преовладава, мислим да и даље све
                    радимо вођени њима, а с друге стране, све што нам се догоди
                    у нама изазове неку емоцију. Оно што је најважнији део
                    стварности мора бити и најважнији део књижевности. Сви
                    догађаји, авантуре, мисли, све те ствари о којима пишемо су
                    на крају небитне ако не изазову емоцију која спаја писца и
                    читаоца.
                  </p>
                </div>
                <div className="author-item">
                  {isMobile ? (
                    <>
                      <img
                        className="author-item_image left"
                        src={Mobile6}
                        alt="Владимир Вукомановић Растегорац"
                      />
                      <Spacer size={40} />
                    </>
                  ) : (
                    <img
                      className="author-item_image right"
                      src={Author8}
                      alt="Владимир Вукомановић Растегорац"
                    />
                  )}
                  <p>
                    <Heading rank={4}>
                      <b>Владимир Вукомановић Растегорац</b>
                      <br />
                      писац
                    </Heading>
                    <Spacer />
                    Негде тамо, дубоко у нама, непрестано вибрира оно што нас
                    покреће и чини живим — што донекле и јесте живот у свом
                    најчистијем виду. Зато писати о емоцијама — а нарочито
                    писати за децу — значи стварати пут за упознавање онога што
                    јесмо и онога што су други. Почетак, средина и крај тог пута
                    је емпатија — данас потребна више него икад.
                  </p>
                  {!isMobile && (
                    <img
                      src={Author9}
                      className="books-sample"
                      alt="i to je u redu"
                    />
                  )}
                </div>
                <div className="author-item">
                  <img
                    className="author-item_image left"
                    src={isMobile ? Mobile7 : Author10}
                    alt="Мара Вуковић"
                  />
                  {isMobile && <Spacer size={40} />}
                  <p>
                    <Heading rank={4}>
                      <b>Мара Вуковић</b>
                      <br />
                      списатељица
                    </Heading>
                    <Spacer />
                    Читајући писана дела деца се поистовећују са јунаком приче.
                    Због тога књижевност за децу мора имати ликове који ће
                    читаоцима нудити приче у којима ће препознати своје емоције,
                    које ће их охрабрити, растеретити, поучити, оснажити,
                    пружити им уточиште, али и бити путоказ ка решењу, водич у
                    упознавању самих себе на путу ка одрастању.
                  </p>
                </div>
                <Spacer size={32} />
                <Heading rank={3} centered kind="graphik">
                  Ко је још писао о емоцијама?
                </Heading>
                <Spacer />
              </LayoutColumn>
              <LayoutColumn size={isTablet ? 10 : 14} centered>
                <div className="post-authors">
                  <div className="post-author">
                    <img src={Ellipse1} alt="Јелена Калајџија" />
                    <Heading rank={6}>Јелена Калајџија</Heading>
                    <p>списатељица и библиотекарка</p>
                  </div>
                  <div className="post-author">
                    <img src={Ellipse2} alt="Јелена Палигорић Синкевић" />
                    <Heading rank={6}>Јелена Палигорић Синкевић</Heading>
                    <p>драматуршкиња</p>
                  </div>
                  <div className="post-author">
                    <img src={Ellipse3} alt="Теа Пухарић" />
                    <Heading rank={6}>Теа Пухарић</Heading>
                    <p>редитељка и драматуршкиња</p>
                  </div>
                  <div className="post-author">
                    <img src={Ellipse4} alt="Златко Васић" />
                    <Heading rank={6}>Златко Васић</Heading>
                    <p>писац</p>
                  </div>
                  <div className="post-author">
                    <img src={Ellipse5} alt="Вања Николић" />
                    <Heading rank={6}>Вања Николић</Heading>
                    <p>списатељица и драматуршкиња</p>
                  </div>
                </div>
              </LayoutColumn>
            </div>
          </div>
          <div className="gifts-block">
            <a
              href={urlHelper.gifts(location.query)}
              target="_blank"
              className="gifts-block_link"
            >
              Поклони овај серијал — и целу библиотеку
            </a>
            <Spacer size={48} />
            <img
              className="bookmate-logo logo_footer"
              src="https://a.bmstatic.com/iu/37/196/outside-originalsUPD-728296496f70efa942a27b46e564bf34.svg"
              alt="Bookmate logo"
            />
            <Spacer size={60} />
          </div>
          <div className="post-word">
            <Heading rank={3}>
              <b>Ивана Мијић Немет</b>,<br /> уредница
            </Heading>
            <p>
              Циљ пројекта И ТО ЈЕ У РЕДУ јесте да се деци узраста од 6 до 10
              година понуде квалитетне нове приче које говоре о емоцијама, и
              пријатним и непријатним, нормализују их и уједно подстичу дечју
              машту, креативност и критичко размишљање.
            </p>
            <p>
              Прочитајте интервју са уредницом <br /> на
              <a
                href="https://zurnal.bookmate.com/intervju_ivana_m_nemet?utm_source=bmj&utm_medium=referral&utm_campaign=sr_06_06_2023&utm_content=sr"
                target="_blank"
              >
                <img
                  width="154"
                  height="14"
                  src="https://a.bmstatic.com/iu/161/159/logo-f71407416177f5565233a28dd5128cb4.svg"
                  alt="Bookmate Zurnal"
                />
              </a>
            </p>
          </div>
          <Spacer size={64} />
          <Footer />
        </div>
      </>
    )
  }
}

const PlayerSampleOne = ({ isTablet, isMobile }) => (
  <>
    <span>Послушајте кратке одломке</span>
    <Spacer />
    <iframe
      title="Послушајте кратке одломке"
      width={isTablet || isMobile ? 300 : 420}
      height="370"
      scrolling="no"
      frameBorder="no"
      allow="autoplay"
      src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1632058489%3Fsecret_token%3Ds-BA8G5ed6rLP&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
    ></iframe>
    <div
      style={{
        fontSize: '10px',
        color: '#cccccc',
        lineBreak: 'anywhere',
        wordBreak: 'normal',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        fontFamily:
          'Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif',
        fontWeight: 100,
      }}
    >
      <a
        href="https://soundcloud.com/bookmate-891163390"
        title="Bookmate"
        target="_blank"
        style={{ color: 'white', textDecoration: 'none' }}
      >
        Bookmate
      </a>{' '}
      ·{' '}
      <a
        href="https://soundcloud.com/bookmate-891163390/sets/i-to-je-u-redu"
        title="И то је у реду"
        target="_blank"
        style={{ color: 'white', textDecoration: 'none' }}
      >
        И то је у реду
      </a>
    </div>
  </>
)

export default uiBox(FeelingsOriginal)
